import saveDataToFirebase from './save-data-to-firebase'
import { select, takeEvery, put, takeLatest, all } from 'redux-saga/effects'
import {taskNames} from '../study-logic/study-redux-slice'
import saveMp3 from './save-mp3'
import {setSaveSuccess, setAudioSuccess,
    setFinalSave, toggleLoading} from './firebase-redux-slice'
import {saveUserContactData, saveUserPublicData} from './save-final-user-data'

function *saveAudioData(userID, date, label, blobURL) {
    const response = yield saveMp3(blobURL, userID, date, label)
        .then(() => 'success')
        .catch((err) => {
            console.log(err)
            return 'failure'
        })
    response === 'success' ? (
        yield put(setAudioSuccess(true))
    ) : (
        yield put(setAudioSuccess(false))
    )
}

function *saveData(action) {
    const {userID, date, data} = yield select(state => ({
        userID: state.study.userVars.userID,
        date: state.study.userVars.date,
        data: state.study.data,
    }))
    if (! action.payload.data){
        return
    } else {
        const savingThinkAloud = action.payload.data
            .hasOwnProperty(taskNames.thinkAloud)
        if (savingThinkAloud) {
            yield saveAudioData(userID, date, taskNames.thinkAloud,
                action.payload.data[taskNames.thinkAloud])
        }
            const response = yield saveDataToFirebase(userID, date, data)
                .then(() => 'success')
                .catch((err) => {
                    console.log(err)
                    return 'failure'
                })
            response === 'success' ? (
                yield put(setSaveSuccess(true))
            ) : (
                yield put(setSaveSuccess(false))
            )
        }
}

function *saveFinalData(action) {
    yield put(toggleLoading())
    const {data, firebase, userVars} = yield select(state => ({
        data: state.study.data,
        firebase: state.firebase,
        userVars: state.study.userVars
    }))
    const {userID, startTime, date, timesCompleted} = userVars
    const {storedAudioFile, finalSave} = firebase

    let savedUserData
    if (!finalSave.userData) {
        const publicUserData = {startTime, date, timesCompleted}
        const publicResponse = yield saveUserPublicData(userID, publicUserData)
            .then(() => 'success').catch(() => 'failure')
        savedUserData = publicResponse === 'success'
    } else {
        savedUserData = finalSave.userData
    }

    let savedContactData
    if (!finalSave.recontact) {
        const recontactResponse = yield saveUserContactData(userID, action.payload)
            .then(() => 'success').catch(() => 'failure')
        savedContactData = recontactResponse === 'success'
    } else {
        savedContactData = finalSave.recontact
    }

    let savedData
    if (!finalSave.data) {
        const expTime = Date.now() - startTime
        const response = yield saveDataToFirebase(userID, date, {...data, expTime})
            .then(() => 'success')
            .catch(() => 'failure')
        savedData = response === 'success'
    } else {
        savedData = finalSave.data
    }

    let savedAudio
    if (!finalSave.audio && !storedAudioFile && data.hasOwnProperty(taskNames.thinkAloud)) {
        const blobURL = data[taskNames.thinkAloud]
        const audioResponse = yield saveMp3(blobURL, userID, date)
            .then(() => 'success').catch(() => 'failure')
        savedAudio = audioResponse === 'success'
    } else {
        savedAudio = storedAudioFile
    }

    const finalSaveData = {
        userData: savedUserData,
        recontact: savedContactData,
        data: savedData,
        audio: savedAudio
    }
    yield put(setFinalSave(finalSaveData))
    yield put(toggleLoading())
}

export default function *rootSaga() {
    yield takeEvery('study/nextTask', saveData)
    yield takeLatest('study/setUserContact', saveFinalData)
}